import logoUrl from "@/assets/scs-logo.webp";

let logoPromise: Promise<HTMLImageElement> | null = null;

function loadLogo(): Promise<HTMLImageElement> {
  if (!logoPromise) {
    logoPromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
      img.src = logoUrl;
    });
  }
  return logoPromise;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}

/**
 * Composite the SCS logo into the bottom-right of `srcUrl` and return a blob: URL
 * to the watermarked image. Right-click → Save delivers the watermarked bytes.
 */
export async function bakeWatermark(srcUrl: string): Promise<string> {
  const [logo, src] = await Promise.all([loadLogo(), loadImage(srcUrl)]);
  const canvas = document.createElement("canvas");
  canvas.width = src.naturalWidth;
  canvas.height = src.naturalHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2d context unavailable");
  ctx.drawImage(src, 0, 0);
  // Watermark size scales with image (~8% of shorter edge), clamped
  const minEdge = Math.min(canvas.width, canvas.height);
  const wmSize = Math.max(56, Math.min(180, minEdge * 0.08));
  const margin = wmSize * 0.4;
  ctx.globalAlpha = 0.3;
  ctx.drawImage(
    logo,
    canvas.width - wmSize - margin,
    canvas.height - wmSize - margin,
    wmSize,
    wmSize,
  );
  ctx.globalAlpha = 1;
  return new Promise<string>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return reject(new Error("canvas toBlob failed"));
        resolve(URL.createObjectURL(blob));
      },
      "image/webp",
      0.9,
    );
  });
}
